import * as S from './GrayoutZone.styled'

export const GrayoutZone = (props) => {
  return (
    <>
      <S.TopZone {...props} />
      <S.RightZone {...props} />
      <S.BottomZone {...props} />
      <S.LeftZone {...props} />
    </>
  )
}

export default GrayoutZone
